import { EndpointCall, retrieve } from "components/http/endpoint";
import { ApiUriPrefix } from "../apiUriPrefix";

const CountriesApiUri = ApiUriPrefix + "countries";

function load(all: boolean = false, filter: string = null): EndpointCall {
    const filterUri = filter !== null ? '&' + encodeURIComponent(filter) : '';
    const uri = `${CountriesApiUri}?all=${all}${filterUri}`;
    return retrieve(uri); // retrieveCollection ???
}


export {
    load,
}